const getVolumeEmbedHost = (communityDomain: string) => {
  // Specifies the Volume embed host.
  // Return early if in production.
  if (process.env.NODE_ENV === "production") {
    return "https://volume.vox-cdn.com";
  }
  const sandboxRegex = /sb\d\d?/;
  const sandbox = communityDomain.match(sandboxRegex);
  const sb = (sandbox && sandbox[0]) || "";
  const isVoxops = communityDomain.includes(".voxops.");

  // Uses production host by default.
  const volumeEmbedHost =
    sb.length === 0
      ? "https://volume.vox-cdn.com"
      : `https://volume.${sb}.k8s.${isVoxops ? "voxops" : "sbndev"}.net`;

  return volumeEmbedHost;
};

export default getVolumeEmbedHost;
